import { Box, CircularProgress } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router-dom";
import Details from "src/shared/components/Details/Details";
import useGetEmailDetails from "../data-access/useGetEmailDetails";
import BackButton from "src/shared/components/Buttons/BackButton";

function MailboxDetails() {
  const { emailType, id } = useParams();
  if (!emailType || !id) return <Navigate to="/email/mailbox" />;
  const { t } = useTranslation();
  const { data, isLoading } = useGetEmailDetails({ emailType, id });
  const emailData = data?.data?.emailData;
  const emailBodySections = useMemo(
    () =>
      (emailData?.body || "")
        .split("</pre>")
        .map((section) => section.trim().replace(/-{3,}/, ""))
        .filter(Boolean),
    [emailData?.body],
  );
  const rows = [
    {
      key: "sent-date",
      name: t("Ημερομηνία Αποστολής:"),
      value: emailData?.datesent,
    },
    {
      key: "message-category",
      name: t("Κατηγορία Μηνύματος"),
      value: emailData?.emailtype,
    },
    {
      key: "subject",
      name: t("Θέμα"),
      value: emailData?.subject,
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        minWidth: "60vw",
        maxWidth: "80rem",
        mx: "auto",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <BackButton
        title={t("Μετάβαση στην Θυρίδα Μηνυμάτων")}
        to="/email/mailbox"
      />
      <h3>{t("Αναλυτικά στοιχεία e-mail")}</h3>
      <Box style={{ width: "100%", maxWidth: "80vw" }}>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
            }}
          >
            <Details rows={rows} />
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  lg: emailBodySections.length > 1 ? "1fr 1fr" : "1fr",
                },
                gap: "1rem",
              }}
            >
              {emailBodySections.map((section, index) => (
                <Box
                  key={`email-section-${index}`}
                  sx={{
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: "8px",
                    p: "1rem",
                    backgroundColor: "background.paper",
                    maxWidth: "100%",
                    overflow: "hidden",
                    "& pre": {
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      fontFamily: "inherit",
                      lineHeight: 1.5,
                      margin: 0,
                    },
                    "& *": {
                      maxWidth: "100%",
                    },
                  }}
                  dangerouslySetInnerHTML={{ __html: section }}
                />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default MailboxDetails;
